/* ============================================================
   RAJATHEE — Orphaned Add-on Cleanup + per-row addon removal
   Extracted from layout/theme.liquid. With defer, this script
   runs before DOMContentLoaded fires, so the addEventListener
   below still catches the event.

   Section rendering: every /cart/update.js and /cart/change.js
   call that mutates the cart includes `sections=...` so Shopify
   returns fresh section HTML. We morph that HTML back into the
   DOM so cart-summary MRP/subtotal stay in sync with the cart
   state (Liquid computes them at render time, so without a
   re-render the totals "ghost" after silent orphan removal).
   ============================================================ */
(function() {
  let isCleaningUp = false;

  function collectSectionIds() {
    return [...new Set(
      [...document.querySelectorAll('cart-items-component[data-section-id]')]
        .map(el => el.dataset.sectionId)
        .filter(Boolean)
    )];
  }

  function applySectionsToDom(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(sectionId => {
      const el = document.querySelector('[data-section-id="' + sectionId + '"]');
      if (!el) return;
      const parsed = new DOMParser().parseFromString(sections[sectionId], 'text/html');
      const newEl = parsed.querySelector('[data-section-id="' + sectionId + '"]');
      if (newEl) el.innerHTML = newEl.innerHTML;
    });
  }

  async function removeOrphanedAddons() {
    if (isCleaningUp) return;
    isCleaningUp = true;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const allKeys = new Set(cart.items.map(item => item.key));
      const orphans = cart.items.filter(item => {
        const parentKey = item.properties && item.properties['_parent_key'];
        return parentKey && !allKeys.has(parentKey);
      });
      if (orphans.length === 0) return;

      const updates = {};
      orphans.forEach(item => { updates[item.key] = 0; });

      const sectionIds = collectSectionIds();
      const body = sectionIds.length
        ? { updates, sections: sectionIds.join(',') }
        : { updates };

      const updated = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(r => r.json()).catch(() => null);

      if (updated && updated.sections) applySectionsToDom(updated.sections);

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: updated,
          itemCount: updated ? updated.item_count : (cart.item_count - orphans.length)
        }
      }));
    } catch(e) {
      console.warn('Orphan cleanup error:', e);
    } finally {
      isCleaningUp = false;
    }
  }

  document.addEventListener('click', function(e) {
    const addonBtn = e.target.closest('[data-addon-key]');
    if (!addonBtn) {
      const removeBtn = e.target.closest('.cart-items__remove');
      if (removeBtn) setTimeout(removeOrphanedAddons, 1500);
      return;
    }
    e.stopPropagation();
    e.preventDefault();
    const addonKey = addonBtn.dataset.addonKey;
    if (!addonKey || addonKey === 'pending') return;
    addonBtn.disabled = true;
    const addonRow = addonBtn.closest('.cart-items__addon-row') || addonBtn.closest('.rj-addon-row');
    if (addonRow) {
      addonRow.style.opacity = '0';
      addonRow.style.transition = 'opacity 0.15s';
      setTimeout(() => addonRow.remove(), 150);
    }
    const sectionIds = collectSectionIds();
    const changeBody = { id: addonKey, quantity: 0 };
    if (sectionIds.length) changeBody.sections = sectionIds.join(',');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(changeBody)
    })
    .then(r => r.json())
    .then(cart => {
      if (cart && cart.sections) applySectionsToDom(cart.sections);
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true, detail: { resource: cart, itemCount: cart.item_count }
      }));
    })
    .catch(e => console.warn('Addon remove error:', e));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeOrphanedAddons);
  } else {
    removeOrphanedAddons();
  }
  document.addEventListener('cart:update', function() { setTimeout(removeOrphanedAddons, 500); });
})();
